import PageDetail from "../abstract/PageDetail.js";

export default class PageLookupDetail extends PageDetail {
	constructor() {
		super();
	}

	handleErrors(rs) {
		// Overridata per gestire in modo custom gli errori non legati ai singoli campi ma più generali (il messaggio compare in una modal)

		if (rs.StatusCode === 401) {
			return "You do not have permission for this action to complete!"
		}
		if (rs.StatusCode === 412) {
			return "You cannot put this in draft because this item is linked elsewhere!"
		}

		return PageLookupDetail.GENERIC_SAVE_ERROR; //500
	}

	getFieldErrorReturnedByServer(rs, code) {
		// Overridata per gestire in modo custom gli errori legati ai campi che arrivano dal server (il messaggio compare vicino al campo in questione)
		if (code === PageLookupDetail.ERROR_FIELD_CODE_NOT_UNIQUE) {
			return "This code has already been used (must be unique for every entry)";
		}
		if (code === PageLookupDetail.ERROR_ForeignKeyConstraintFailed) {
			return "You cannot delete because this item is linked elsewhere!";
		}
		return code;
	}
}

PageLookupDetail.ERROR_FIELD_CODE_NOT_UNIQUE = "UniqueFieldConstraintFailed";

